/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// disabled because: let the compiler infer the types
import type { ConversationHistory } from 'lib-shared-types-api';
import { createSelector } from 'reselect';

import { AppState } from 'bootstrap.store';

import { extractConversationTextFromMessages } from '../../../elevio/src/utils/messages';

/**
 * There seems to be no way to find a standard type for this data shape, in
 * particular the data.data.
 *
 * Using conversationsApi.endpoints.readConversation.initiate({csid:
 * conversationId}) in lieu of `conversation =
 * store.api.queries[conversationKey];` was not helpful as the return type did
 * not map directly to what's in the store.
 */
type StoreConversation = {
  data: {
    data: { history: ConversationHistory };
  };
};

/** Selects conversation Tag[] */
const tagsSelector = createSelector(
  (store: AppState) => {
    const conversationId = store.conversation.metaConversation.conversation.id;
    if (!conversationId) return [];

    const conversationKey = `readConversation({"csid":${conversationId}})`;
    const conversation = store.api?.queries[conversationKey];

    const conversationTags =
      (conversation as unknown as StoreConversation)?.data?.data?.history
        .main_conversation.tags || [];
    const legacyTags =
      store.conversation.metaConversation.conversation.tags || [];

    const tags =
      !conversation || !conversationTags ? legacyTags : conversationTags;

    return tags;
  },
  (tags) => tags,
);
const messagesSelector = createSelector(
  (store: AppState) => store.conversation.metaConversation.messages,
  (messages) => messages,
);
const conversationSelectors = {
  id: (store: AppState) =>
    store.conversation.metaConversation.conversation.id || null,
  tags: tagsSelector,
  /** List of messages in a conversation as a single piece of text */
  text: createSelector(messagesSelector, (messages) =>
    extractConversationTextFromMessages(messages),
  ),
  queueId: (store: AppState) =>
    store.conversation.metaConversation.conversation.queue?.id || '',
};

export const knowledgeSelectors = {
  conversation: conversationSelectors,
};
